import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { NavLocationAreas } from '~src/spacesPlatform/components/layout/NavLocation';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ContentRelayPlanDetailsSpaceContainer } from './ContentRelayPlanDetailsSpaceContainer';
import { ContentRelayPlanTab } from './ContentRelayPlanTab';

export interface ContentRelayPlanDetailsSpaceProviderProps {
  /** LUID of the plan being shown, parsed from the route. */
  readonly planLuid: string;
  readonly urls: SpacesSiteUrls;
  /** Which tab the matched route shows; defaults to Overview. */
  readonly activeTab?: ContentRelayPlanTab;
}

function planDetailsSpaceInfo(subspaceName: ContentRelayPlanTab): SpaceInfo {
  return {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'contentRelayPlanDetails',
    subspaceName: subspaceName,
    // Keep "Content Relays" highlighted in the side nav while on a plan.
    navLocationOverride: NavLocationAreas.SiteContent.content_relay,
  };
}

// Module-level so each tab keeps one stable object across renders.
const ContentRelayPlanDetailsSpaceInfos: { [tab in ContentRelayPlanTab]: SpaceInfo } = {
  overview: planDetailsSpaceInfo('overview'),
  executions: planDetailsSpaceInfo('executions'),
};

/**
 * Provider for the Content Relay plan detail page (#/contentRelayPlans/:luid[/executions]). Sets the space info,
 * then renders the container that loads the plan and owns page state.
 */
export const ContentRelayPlanDetailsSpaceProvider: React.FunctionComponent<ContentRelayPlanDetailsSpaceProviderProps> = props => {
  const activeTab = props.activeTab || 'overview';
  return (
    <ConnectedSpaceInfoProvider spaceInfo={ContentRelayPlanDetailsSpaceInfos[activeTab]}>
      <ContentRelayPlanDetailsSpaceContainer planLuid={props.planLuid} urls={props.urls} activeTab={activeTab} />
    </ConnectedSpaceInfoProvider>
  );
};
